import { useQuery } from '@tanstack/react-query';

import { feedbackClient } from '../client/feedbackClient';
import { cacheKeys } from '../config';


type Options = {
  enabled?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useFeedbackSession = (options: Partial<Options> = defaultOptions) => {
  const { data: { data: session } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getOngoingFeedbackSession],
    queryFn: () => feedbackClient.getOngoingSession(),
    ...options,
  });
  return { ...rest, session };
};
